<template>
  <div class="invite-wrap">
    <div class="invite-head">
      <div class="invite-title">邀请下单</div>
      <div class="invite-close" @click="closeProduct"></div>
    </div>

    <div v-if="step === 1" class="invite-body">
      <div class="invite-toolbar">
        <div class="invite-sec">服务商品选择</div>
        <div class="invite-search">
          <input v-model="seachvalue" placeholder="搜索服务商品" @keyup.enter="getProduct" />
          <span class="invite-search-btn" @click="getProduct">搜</span>
        </div>
      </div>
      <div class="invite-list">
        <div
          v-for="item in productList"
          :key="item.id"
          :class="['spu-card', item.select ? 'spu-card-on' : '']"
          @click="pickProduct(item)"
        >
          <img class="spu-cover" :src="item.picUrl" />
          <div class="spu-main">
            <div class="spu-name">{{ item.name }}</div>
            <div class="spu-tags">
              <span v-for="(t, i) in getTags(item)" :key="i" :class="i === 0 && isCouponTag(t) ? 'tag-red' : 'tag-gray'">{{ t }}</span>
            </div>
            <div class="spu-price">¥ {{ startPrice(item) }}起</div>
          </div>
          <div v-if="item.select" class="spu-check">✓</div>
        </div>
      </div>
      <div class="invite-foot">
        <div class="invite-send" :class="current ? '' : 'invite-send-off'" @click="goStep2">下一步</div>
      </div>
    </div>

    <div v-else class="invite-body">
      <div class="picked-card">
        <img class="spu-cover" :src="current.picUrl" />
        <div class="spu-main">
          <div class="spu-name">{{ current.name }}</div>
          <div class="spu-tags">
            <span v-for="(t, i) in getTags(current)" :key="i" :class="i === 0 && isCouponTag(t) ? 'tag-red' : 'tag-gray'">{{ t }}</span>
          </div>
          <div class="spu-price">¥ {{ startPrice(current) }}起</div>
        </div>
        <div class="picked-change" @click="step = 1">更换</div>
      </div>
      <div class="field">
        <div class="field-label">服务单价<span class="field-hint">（{{ identityLabel }}）</span></div>
        <div class="field-box field-box-ro">
          <span class="unit-price-ro">{{ unitPrice || '—' }}</span>
          <span>元</span>
        </div>
      </div>
      <div class="field">
        <div class="field-label">图纸平米</div>
        <div class="field-box">
          <input v-model="area" type="number" min="0" placeholder="请输入平米" />
          <span>平米</span>
        </div>
      </div>
      <div class="field">
        <div class="field-label">支付模式</div>
        <div class="pay-mode">
          <div class="pay-btn on">全款支付</div>
        </div>
      </div>
      <div class="invite-foot step2-foot">
        <div class="total">应付总额：<b>{{ totalText }}元</b></div>
        <div class="invite-send" @click="comSend">发送支付链接</div>
      </div>
    </div>
  </div>
</template>
<script>
import { requestHttpGet, requestHttpPostByOnline } from '@/api/main'
import storage from 'store2'
import apiUrl from '@/utils/config'
export default {
  name: 'InviteOrder',
  props: {
    userId: { type: String, default: '' },
    type: { type: String, default: '' },
    demandId: { type: Number, default: 0 },
    // 0=个人业主 1=装修公司；不传则按对方 mb_ 账号自行查询
    identityType: { type: [Number, String], default: null }
  },
  data() {
    return {
      step: 1,
      seachvalue: '',
      productList: [],
      current: null,
      unitPrice: '',
      area: '',
      resolvedIdentityType: null
    }
  },
  computed: {
    totalText() {
      const u = parseFloat(this.unitPrice)
      const a = parseFloat(this.area)
      if (!u || u <= 0 || !a || a <= 0) return '0.00'
      return (u * a).toFixed(2)
    },
    identityLabel() {
      return this.memberIdentityType === 1 ? '装修公司价' : '个人业主价'
    },
    // 已查到的身份优先；父组件未查完(null)时不抢先按个人业主计价
    memberIdentityType() {
      if (this.resolvedIdentityType !== null && this.resolvedIdentityType !== undefined) {
        return Number(this.resolvedIdentityType)
      }
      if (this.identityType !== null && this.identityType !== undefined && this.identityType !== '') {
        return Number(this.identityType)
      }
      return 0
    }
  },
  watch: {
    identityType(val) {
      if (val === null || val === undefined || val === '') return
      this.resolvedIdentityType = Number(val)
      this.syncUnitPriceByIdentity()
    },
    memberIdentityType() {
      this.syncUnitPriceByIdentity()
    }
  },
  async mounted() {
    await this.resolveIdentity()
    await this.getProduct()
  },
  methods: {
    closeProduct() {
      this.$emit('close')
    },
    /** 始终以会员接口身份为准；prop 仅作兜底（父组件曾默认 0 会误判为个人业主） */
    async resolveIdentity() {
      const uid = this.userId || ''
      if (uid.indexOf('mb_') === 0) {
        try {
          const res = await requestHttpGet(apiUrl + '/admin-api/supplier/user/user-member-info', {
            id: uid.split('mb_')[1]
          })
          if (res && res.data && res.data.identityType != null) {
            this.resolvedIdentityType = Number(res.data.identityType)
            return
          }
        } catch (e) {
          // 查不到再回落 prop
        }
      }
      if (this.identityType !== null && this.identityType !== undefined && this.identityType !== '') {
        this.resolvedIdentityType = Number(this.identityType)
      }
    },
    syncUnitPriceByIdentity() {
      if (this.step !== 2 || !this.current) return
      this.unitPrice = this.startPrice(this.current)
    },
    // 与 APP 一致：多规格按「个人业主 / 装修公司」选 SKU
    pickSku(item) {
      const skus = (item && item.skus) || []
      if (!skus.length) return null
      if (skus.length === 1) return skus[0]
      const want = this.memberIdentityType === 1 ? '装修公司' : '个人业主'
      const hit = skus.find(s => {
        const props = s.properties || []
        return props.some(p => p && (p.valueName === want || p.name === want))
      })
      return hit || skus[0]
    },
    isCouponTag(t) {
      return t && String(t).indexOf('券') >= 0
    },
    getTags(item) {
      const tags = []
      if (item && item.keyword) {
        String(item.keyword).split(/[,，、\s]+/).forEach(t => {
          if (t) tags.push(t)
        })
      }
      const sku = this.pickSku(item)
      if (sku && sku.properties) {
        sku.properties.forEach(p => {
          if (p.valueName) tags.push(p.valueName)
        })
      }
      return Array.from(new Set(tags)).slice(0, 8)
    },
    startPrice(item) {
      const sku = this.pickSku(item)
      const fen = sku && sku.price != null
        ? sku.price
        : (item && item.price != null ? item.price : 0)
      // 分转元，保留两位小数（真实价格）；toFixed(0) 会丢角分
      return (Number(fen) / 100).toFixed(2)
    },
    pickProduct(item) {
      this.productList.forEach(e => { e.select = e.id === item.id })
      this.current = item
    },
    async goStep2() {
      if (!this.current) return
      await this.resolveIdentity()
      this.unitPrice = this.startPrice(this.current)
      this.area = ''
      this.step = 2
    },
    async getProduct() {
      const obj = { shopType: storage.get('shopType') }
      if (this.seachvalue) obj.name = this.seachvalue
      const res = await requestHttpPostByOnline(apiUrl + '/admin-api/product/spu/get-list-pc-im', obj)
      this.productList = []
      ;(res.data || []).forEach(e => {
        e.select = this.current && this.current.id === e.id
        e.skus = e.skus || []
        this.productList.push(e)
      })
      if (this.current) {
        const hit = this.productList.find(e => e.id === this.current.id)
        if (hit) this.current = hit
      }
    },
    async comSend() {
      if (!this.current) return
      await this.resolveIdentity()
      // 单价只读，始终按聊天用户身份 SKU 计价后写入消息 price
      this.unitPrice = this.startPrice(this.current)
      const u = parseFloat(this.unitPrice)
      const a = parseFloat(this.area)
      if (!u || u <= 0) return
      if (!a || a <= 0) return
      const sku = this.pickSku(this.current)
      const skuId = sku && sku.id
      if (!skuId) return
      const unitFen = Math.round(u * 100)
      const priceFen = Math.round(unitFen * a)
      const count = Math.max(1, Math.round(a))
      const param = [{
        skuId,
        count,
        cartId: 0,
        demandId: this.demandId,
        area: a,
        unitPrice: unitFen,
        payMode: 'full',
        identityType: this.memberIdentityType
      }]
      const obj = {
        orderId: '',
        image: (sku && sku.picUrl) || this.current.picUrl,
        name: this.current.name,
        titleName: '已帮您选择好商品规格。',
        price: priceFen,
        designerId: 0,
        tenantId: 0,
        identityType: this.memberIdentityType,
        ext: JSON.stringify(param),
        type: 'selectOrder'
      }
      this.$ImSdk.sendCustomMessages(this.userId, this.type, obj, this, {}, 0)
      this.closeProduct()
    }
  }
}
</script>
<style scoped>
.invite-wrap { font-family: PingFang SC, sans-serif; color: #222; }
.invite-head { display: flex; align-items: center; justify-content: space-between; padding: 4px 4px 16px; }
.invite-title { font-size: 16px; font-weight: 600; }
.invite-close { width: 16px; height: 16px; background: url('~@/assets/main-close.png') center/100% no-repeat; cursor: pointer; }
.invite-body { min-height: 460px; position: relative; padding-bottom: 64px; }
.invite-toolbar { display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px; }
.invite-sec { font-size: 14px; font-weight: 600; }
.invite-search { display: flex; align-items: center; width: 220px; height: 32px; border: 1px solid #eee; border-radius: 16px; padding: 0 10px; }
.invite-search input { border: 0; outline: none; flex: 1; font-size: 12px; }
.invite-search-btn { color: #999; font-size: 12px; cursor: pointer; }
.invite-list { max-height: 420px; overflow: auto; }
.spu-card { display: flex; align-items: flex-start; border: 1px solid #eee; border-radius: 8px; padding: 12px; margin-bottom: 10px; cursor: pointer; position: relative; }
.spu-card-on { border-color: #ED2616; background: #FFF7F6; }
.spu-cover { width: 72px; height: 72px; border-radius: 6px; object-fit: cover; flex-shrink: 0; }
.spu-main { margin-left: 12px; flex: 1; min-width: 0; }
.spu-name { font-size: 14px; font-weight: 600; }
.spu-tags { margin-top: 6px; display: flex; flex-wrap: wrap; gap: 6px; }
.tag-red { color: #ED2616; background: #FFF1F0; border: 1px solid #FFD4D0; font-size: 11px; padding: 1px 6px; border-radius: 2px; }
.tag-gray { color: #888; background: #F7F7F7; border: 1px solid #EEE; font-size: 11px; padding: 1px 6px; border-radius: 2px; }
.spu-price { margin-top: 8px; color: #ED2616; font-weight: 600; }
.spu-check { position: absolute; right: 10px; top: 10px; width: 18px; height: 18px; border-radius: 50%; background: #ED2616; color: #fff; font-size: 12px; line-height: 18px; text-align: center; }
.picked-card { display: flex; align-items: flex-start; padding-bottom: 16px; border-bottom: 1px solid #eee; }
.picked-change { color: #ED2616; font-size: 13px; cursor: pointer; flex-shrink: 0; }
.field { margin-top: 16px; }
.field-label { font-size: 14px; font-weight: 600; margin-bottom: 8px; }
.field-hint { margin-left: 6px; font-size: 12px; font-weight: 400; color: #999; }
.field-box { display: flex; align-items: center; border: 1px solid #eee; border-radius: 6px; height: 40px; padding: 0 12px; }
.field-box-ro { background: #F7F7F7; color: #666; cursor: default; }
.unit-price-ro { flex: 1; font-size: 14px; color: #222; font-weight: 600; }
.field-box input { border: 0; outline: none; flex: 1; }
.field-box span { color: #999; font-size: 13px; }
.pay-mode { display: flex; gap: 8px; }
.pay-btn { min-width: 88px; height: 32px; line-height: 32px; text-align: center; border: 1px solid #eee; border-radius: 4px; font-size: 13px; }
.pay-btn.on { background: #ED2616; color: #fff; border-color: #ED2616; }
.invite-foot { position: absolute; left: 0; right: 0; bottom: 0; display: flex; flex-wrap: nowrap; justify-content: flex-end; align-items: center; gap: 12px; }
.step2-foot { justify-content: space-between; align-items: center; background: #FFF7F6; margin: 16px -8px -8px; padding: 12px 8px; }
.total { color: #222; flex: 1 1 auto; min-width: 0; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; } .total b { color: #ED2616; }
.invite-send { flex: 0 0 auto; background: #ED2616; color: #fff; border-radius: 4px; padding: 8px 18px; cursor: pointer; white-space: nowrap; }
.invite-send-off { opacity: .4; pointer-events: none; }
</style>
